module.exports = __webpack_public_path__ + "static/img/shz.41442b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shz.png
// module id = ip8+
// module chunks = 167